<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>New Firm Application</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-row v-if="loadingChecklist" class="pa-4">
        <v-col cols="12" md="3">
          <v-skeleton-loader
            class="mx-auto"
            type="list-item-avatar-three-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto mt-3"
            type="list-item-avatar-three-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto mt-3"
            type="list-item-avatar-three-line"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="9">
          <v-skeleton-loader type="image, article"></v-skeleton-loader>
        </v-col>
      </v-row>

      <v-tabs v-else v-model="activeTab" vertical>
        <v-tab
          v-for="(item, index) in checklist"
          :key="index"
          class="justify-start"
        >
          <v-icon left>
            {{ item.pass ? "mdi-check-circle" : "mdi-circle-outline" }}
          </v-icon>
          {{ item.checkListType }}
        </v-tab>

        <v-tab-item v-for="(item, index) in checklist" :key="index">
          <v-card flat>
            <v-card-text>
              <component
                :is="getComponent(item.checkListType)"
                ref="activeComponent"
                :initial="true"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="prevStep"
                v-if="activeTab > 0"
                :disabled="loading"
              >
                Previous
              </v-btn>
              <v-btn
                color="primary"
                @click="nextStep"
                v-if="activeTab < checklist.length - 1"
                :loading="loading"
              >
                Next
              </v-btn>
              <v-btn
                color="success"
                @click="submitApplication"
                v-if="activeTab === checklist.length - 1"
                :loading="loading"
              >
                Submit Application
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import Bio from "../../profile/components/bio/Bio";
import Contact from "../../profile/components/contact/Contact";
import Experience from "../../profile/components/experience/Experience";
import Certification from "../../profile/components/certification/Certification";
import Referee from "../../profile/components/referee/Referee";
import Specialization from "../../profile/components/specialization/Specialization";
import Conviction from "../../profile/components/conviction/Conviction";
import Attachments from "../../profile/components/attachment/Attachments";
import Services from "../../profile/components/services/Services.vue";
import Directors from "../../profile/components/directors/Director.vue";
import FirmEmployee from "../../profile/components/employees/Employee.vue";
import Shareholders from "../../profile/components/shareholders/Shareholder.vue";
import FirmBankers from "../../profile/components/bankers/Banker.vue";
import Facilities from "../../profile/components/facilities/Facility.vue";
import Institution from "../../profile/components/institution/Institution.vue";
import Firmbio from "../../profile/components/firmbio/Firmbio.vue";
import FirmMembers from "../../profile/components/firmMembers/FirmMembers.vue";

export default {
  name: "FirmCard",
  components: {
    Bio,
    Contact,
    Experience,
    Certification,
    Referee,
    Specialization,
    Conviction,
    Attachments,
    Services,
    Directors,
    FirmEmployee,
    Shareholders,
    FirmBankers,
    Facilities,
    Institution,
    Firmbio,
    FirmMembers,
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
    };
  },
  computed: {
    checklist() {
      return this.$store.getters["Checklist/checklist"];
    },
    loadingChecklist() {
      return this.$store.getters["Checklist/loadingChecklist"];
    },
  },
  mounted() {
    this.fetchChecklist();

    if (this.$route.params?.firmCode) {
      this.fetchFirmBio();
    }

    Event.$on("on-save-firm-bio", (firmApplication) => {
      if (
        !firmApplication ||
        !firmApplication?.profileID ||
        !firmApplication?.code
      )
        return;
      this.$router.push({
        name: "firm-card",
        params: {
          firmCode: firmApplication.profileID,
          application: firmApplication.code,
        },
      });
    });
  },
  watch: {
    $route: {
      handler(route) {
        console.log("route at watch: ", route);
      },
      deep: true,
    },
  },
  methods: {
    fetchChecklist() {
      this.$store.dispatch("Checklist/getChecklist", {
        category: "FIRM", // Assuming Corporate for firms, verify if needed
        type: "Firm Application",
      });
    },
    fetchFirmBio() {
      const firmCode = this.$route.params.firmCode;
      if (firmCode) {
        this.$store.dispatch("Profile/getFirmBio", {
          ProfileID: firmCode,
        });
      }
    },
    getComponent(componentName) {
      switch (componentName) {
        case "PROFILE":
        case "PICTURE":
        case "RESIDENCE":
        case "ID":
          return Bio;
        case "CONTACTS":
        case "ADDRESS":
          return Contact;
        case "OLEVEL":
        case "EDUCATION":
          return Certification;
        case "PROFESSIONAL":
        case "IEK":
          return Institution;
        case "WORK EXPERIENCE":
          return Experience;
        case "REFEREE":
        case "PROPOSER":
        case "SECONDER":
          return Referee;
        case "SPECILIZATION":
          return Specialization;
        case "CONVICTION":
          return Conviction;
        case "ATTACHMENTS":
          return Attachments;
        case "SERVICES":
          return Services;
        case "DIRECTORS":
          return Directors;
        case "FIRMEMPLOYEES":
          return FirmEmployee;
        case "SHAREHOLDERS":
          return Shareholders;
        case "FIRMBANKERS":
          return FirmBankers;
        case "FACILITIES":
          return Facilities;
        case "COMPANYINFORMATION":
          return Firmbio;
        case "FIRM MEMBERS":
        case "FIRMMEMBERS":
          return FirmMembers;
        default:
          return Attachments;
      }
    },
    async saveCurrentStep() {
      this.loading = true;
      try {
        // Access the active component
        // Note: refs inside v-for are arrays
        const components = this.$refs.activeComponent;
        const currentComponent = components[this.activeTab];

        if (currentComponent) {
          // Try to find a save method
          if (typeof currentComponent.saveProfile === "function") {
            await currentComponent.saveProfile();
          } else if (typeof currentComponent.save === "function") {
            await currentComponent.save();
          } else if (typeof currentComponent.submit === "function") {
            await currentComponent.submit();
          } else {
            console.warn(
              "No save method found for component",
              currentComponent
            );
          }
        }
      } catch (e) {
        console.error("Error saving step", e);
      } finally {
        this.loading = false;
      }
    },
    async nextStep() {
      await this.saveCurrentStep();
      if (this.activeTab < this.checklist.length - 1) {
        this.activeTab++;
      }
    },
    async prevStep() {
      await this.saveCurrentStep();
      if (this.activeTab > 0) {
        this.activeTab--;
      }
    },
    async submitApplication() {
      await this.saveCurrentStep();
      // Logic to submit the final application
      // Assuming ApplicationStore has a submit method
      // We might need to gather data or just trigger a status change
      if (confirm("Are you sure you want to submit the application?")) {
        this.$store.dispatch("Application/submit", {
          // Payload if needed
          type: "FIRM",
        });
      }
    },
  },
};
</script>

<style scoped>
.v-tabs-items {
  height: 100%;
}
</style>
